<template>
  <div>
    <va-modal
      title="Bulletin d'adhésion"
      class="modal"
      v-model="showModal"
      max-width="100%"
      :hideDefaultActions="true"
      v-on:cancel="closeModal"
    >
      <div class="row customsize">
        <div class="flex md6 setheight">
          <div
            class="row"
            v-if="pdfAvailable && !showUpload && !changeFile"
          >
            <div class="flex md12">
              <va-button
                class="fullwidth"
                outline
                color="info"
                @click="downloadBulletin"
              >Télécharger</va-button>
            </div>

            <div class="flex md12">
              <va-button
                class="fullwidth"
                outline
                disabled
                v-if="false"
                color="info"
                @click="printBulletin"
              >Imprimer</va-button>
            </div>
            <div class="flex md12">
              <va-button
                class="fullwidth"
                outline
                color="info"
                @click="changeFile = true"
              >Modifier le bulletin d'adhésion</va-button>
            </div>
            <div
              class="flex md12"
              v-if="isAdmin"
            >
              <va-button
                class="fullwidth"
                outline
                color="danger"
                @click="deleteBulletin"
              >Supprimer le bulletin d'adhésion</va-button>
            </div>
          </div>
          <div class="row">
            <div
              class="flex md12"
              v-show="showUpload || fileUploaded"
            >
              <va-button
                class="fullwidth"
                :disabled="!fileUploaded"
                outline
                color="info"
                @click="uploadBulletin"
              >Téléverser le bulletin d'adhésion</va-button>
            </div>
            <div
              class="flex md12"
              v-if="fileUploaded || changeFile"
            >
              <va-button
                class="fullwidth"
                outline
                color="info"
                @click="file = []; changeFile = false"
              >Annuler</va-button>
            </div>
          </div>
          <div class="flex md12 mt-2 fullsize">
            <h4
              class="fullwidth mb-3"
              style="position: relative;
          top: 0.5em;"
            >Actions:</h4>
            <div
              class="row"
              v-if="actions.length < 1"
            >
              <div class="flex md12 mt-3">
                <p class="text--secondary">Aucune actions</p>
              </div>
            </div>
            <div
              class="row actions-container"
              v-if="actions.length > 0"
            >
              <div class="flex md12">
                <template v-for="action in actions">
                  <div class="row pb-2 px-2">
                    <div class="flex md12 text-lighter">
                      Bulletin d'adhésion
                      <b>{{actionsType[action.idaction_type-1]}}</b>
                      par
                      <b>{{action.utilisateur.prenom}} {{action.utilisateur.nom}}</b> le
                      <b>{{convertDate(action.date)}}</b>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="flex md6">
          <va-file-upload
            type="single"
            dropzone
            file-types=".pdf"
            v-model="file"
            color="info"
            v-show="showUpload"
          />
          <iframe
            id="iframeBulletin"
            ref="iframeBulletin"
            v-if="fileUploaded || (pdfurl && !showUpload)"
            class="fullsize"
            :src="pdfSrc"
          />
          <div
            class="solid fullsize"
            @click="displayBulletin"
            v-if="pdfAvailable && !showUpload && !changeFile && !pdfurl"
          >
            <va-icon
              class="center-icon"
              name="fa fa-eye"
              color="info"
              size="5em"
            />
          </div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

    <script>
import axios from "axios";

export default {
  name: "BulletinsAdhesionsManager",
  props: ["value", "idadhesion", "entrepriseName"],
  data() {
    return {
      showModal: false,
      file: [],
      adhesion: this.resetAdhesion(),
      changeFile: false,
      pdfurl: null,
      actions: [],
      actionsType: ["téléversé", "remplacé", "supprimé"],
      //TODO a preciser
      isAdmin:
        this.$store.getters.user.droits &&
        this.$store.getters.user.droits === "ADMIN"
    };
  },
  computed: {
    pdfSrc() {
      if (this.file.length > 0) {
        let url = URL.createObjectURL(this.file[0]);
        return url;
      } else if (this.pdfurl) {
        return this.pdfurl;
      } else {
        return "";
      }
    },
    fileUploaded() {
      return this.file.length > 0 ? true : false;
    },
    pdfAvailable() {
      return this.adhesion.pdfdisponible;
    },
    showUpload() {
      return (this.changeFile || !this.pdfAvailable) && !this.fileUploaded;
    }
  },
  watch: {
    value() {
      this.showModal = this.value;
      // Parent property changed; update internal variables
      if (!this.value) {
        this.resetComponent();
      } else if (!this.idadhesion) {
        // TODO error no idadhesion
        console.log("no adhesion");
      } else {
        this.loadBulletin(this.idadhesion);
      }
    }
  },
  methods: {
    // TODO disable buttons as they are treating the demand
    // TODO deal with errors
    async deleteBulletin() {
      try {
        await axios.delete("api/bulletin-adhesion", {
          params: { idadhesion: this.idadhesion }
        });
        //TODO deal with deletion
        this.resetComponent();
        this.$emit("deleted");
      } catch (err) {
        // TODO deal with error
        console.log(err);
        this.launchEpicmaxToast("Erreur lors de la suppression");
      }
    },
    async printBulletin() {
      try {
        if (!this.pdfurl) {
          await this.getBulletinURL();
        }
        let iframeBulletin = this.$refs.iframeBulletin;
        iframeBulletin.focus();
        iframeBulletin.contentWindow.print();
      } catch (err) {
        // TODO deal with error
        console.log(err);
      }
    },
    async downloadBulletin() {
      try {
        if (!this.pdfurl) {
          await this.getBulletinURL();
        }
        let url = this.pdfurl;

        let response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: "application/pdf"
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Bulletin_Adhesion_" + this.entrepriseName;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        // TODO deal with error
        console.log(err);
        this.launchEpicmaxToast("Erreur lors du téléchargement");
      }
    },
    async getBulletinURL() {
      try {
        let resp = await axios.get("api/bulletin-adhesion", {
          params: { idadhesion: this.idadhesion }
        });
        this.pdfurl = resp.data;
      } catch (err) {
        //TODO manage error
        this.launchEpicmaxToast("Erreur lors de la recherche du bulletin");

        console.log(err);
      }
    },
    async displayBulletin() {
      if (!this.pdfurl) {
        await this.getBulletinURL();
      } else {
        this.displayPdf = true;
      }
    },
    resetAdhesion() {
      return { idadhesion: null, pdfdisponible: false };
    },
    resetComponent() {
      this.file = [];
      (this.changeFile = false), (this.pdfurl = null);
      this.adhesion = this.resetAdhesion();
    },
    async loadBulletin(idadhesion) {
      try {
        //import adhesion
        let res = await axios.get("api/adhesion", {
          params: {
            idadhesion: this.idadhesion
          }
        });
        //reset module
        this.resetComponent();
        this.actions = res.data.actions;
        this.adhesion = res.data.adhesion;
      } catch (error) {
        //manage errors
        console.log(error);
        this.launchEpicmaxToast(
          "Impossible de charger les informations de l'adhesion"
        );
      }
    },
    closeModal() {
      this.resetComponent();
      this.$emit("input", false);
    },
    async uploadBulletin() {
      // TODO DEAL WITH ERROR
      //check that file exist then upload to server
      try {
        if (this.file.length > 0 && this.idadhesion) {
          let formData = new FormData();
          formData.append("bulletin", this.file[0]);
          await axios.put("/api/bulletin-adhesion", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            },
            params: {
              idadhesion: this.idadhesion,
              idutilisateur: this.$store.getters.user.idutilisateurs
            }
          });
          this.$emit("uploaded");
          this.loadBulletin();
        }
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de l'envoi du bulletin");
      }
    },
    convertDate(date) {
      // TODO : move to support functions
      let t = date.split("-");
      return t[2] + "-" + t[1] + "-" + t[0];
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  }
};
</script>

<style scoped>
.customsize {
  width: 60vw;
  height: 50vh;
  overflow: auto;
}
.fullwidth {
  width: 95%;
}

.solid {
  border: 2px solid #4ab2e3;
  border-radius: 25px;
  position: relative;
}
.solid:hover {
  cursor: pointer;
  background: #e5f5fa;
}
.fullsize {
  width: 100%;
  height: 95%;
}

.center-icon {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-lighter {
  color: #b2b2b2;
}

.actions-container {
  overflow: auto;
  height: 100%;
  direction: rtl;
}

.setheight {
  height: 60%;
}
</style>
